import { availableLanguages } from './routes/Header/Language';

export const getCurrentLanguage = match => {
  if (match) {
    return match.params.lang;
  }
  const regex = `/(${availableLanguages.join('|')})/`;
  const matches = window.location.href.match(new RegExp(regex, 'gm'));
  if (matches && matches.length) {
    return matches[0].replaceAll('/', '');
  }
  return 'en';
};

export const getCurrentLanguageSurvey = match => {
  const language = getCurrentLanguage(match);
  if (language === 'en') {
    return 'nl';
  } else {
    return language;
  }
};
